module.exports = __webpack_public_path__ + "a0d372074a83c2090d898c344ca2483d.woff2";